document.addEventListener('DOMContentLoaded', function() {
  function setupVideos() {
    const videos = document.querySelectorAll('video[src*=".mp4"], video source[src*=".mp4"]');
    
    videos.forEach(video => {
      const videoElement = video.tagName === 'SOURCE' ? video.parentElement : video;
      
      // Configurar todos los atributos posibles
      videoElement.autoplay = true;
      videoElement.loop = true;
      videoElement.muted = true;
      videoElement.playsInline = true;
      videoElement.controls = false;
      videoElement.preload = 'auto';
      
      // Atributos HTML
      videoElement.setAttribute('autoplay', '');
      videoElement.setAttribute('loop', '');
      videoElement.setAttribute('muted', '');
      videoElement.setAttribute('playsinline', '');
      videoElement.setAttribute('webkit-playsinline', '');
      
      // Forzar reproducción
      videoElement.load();
      videoElement.play().catch(e => console.log('Autoplay bloqueado:', e));
    });
  }
  
  setupVideos();
  
  // Reintentar en interacción
  ['touchstart', 'click', 'scroll'].forEach(event => {
    document.addEventListener(event, setupVideos, { once: true });
  });
});
